module.exports = __webpack_public_path__ + "static/media/onoake-product-cover.e553f3c1.png";